import { render, staticRenderFns } from "./InfoBall.vue?vue&type=template&id=7c88bc46&scoped=true&"
import script from "./InfoBall.vue?vue&type=script&lang=js&"
export * from "./InfoBall.vue?vue&type=script&lang=js&"
import style0 from "./InfoBall.vue?vue&type=style&index=0&id=7c88bc46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c88bc46",
  null
  
)

export default component.exports